<div
    id="pest-service-insights-container"
    class="flex flex-col pt-6 px-8 gap-6 bg-light-blue ml-neptune-sidebar min-h-[70%] pb-neptune-bar"
  >
    <!-- Add All button, excel description and excel download button -->
    <section
      id="pest-service-insights-header"
      *ngIf="!loading; else headerSkeletonLoader"
      class="flex justify-between items-center"
    >
      <div class="bg-white p-4 flex gap-2 items-center">
        <input
          id="line-chart-checkbox"
          test-id="selectAllBox"
          #addAllBox
          type="checkbox"
          [checked]="allChecked"
          (click)="_onAllCheckedChange(addAllBox.checked)"
        />
        <span class="text-sm">Add All</span>
      </div>

      <div
        id="pest-excel-button-container"
        class="flex gap-4 items-center justify-center"
      >
        <span id="pest-service-call-data-title" class="text-base">
          Services, Findings, ESRs, Scan Pest Counts and PrevOpp Frequency​ Data
        </span>
        <download-spreadsheet-button
          id="spreadsheet-download-button"
        ></download-spreadsheet-button>
      </div>
    </section>
    
    <section id="pest-services" class="bg-white flex flex-col p-6 gap-6 items-center justify-center rounded-lg border-1 border-solid border-neptune-color-primary-200">
      <section id="pest-services-kpi" class="flex gap-6 justify-start w-full items-center pb-6 neptune-border-b-1 border-neptune-color-primary-200">
        <div id="pest-services-title" class="text-2xl text-neptune-color-primary-700">Service Metrics | Services</div>
        <app-service-insights-kpi-bar [kpiName]="pestKpiTypes.ServiceKPI" [serviceType]="ServiceMetricTypes.Services"></app-service-insights-kpi-bar>
      </section>
      <section id="pest-services-distribution-chart" class="w-full">
        <service-call-distribution-chart
          [items]="serviceDistributionItems"
          [serviceMetricType]="ServiceMetricTypes.Services"
          [loading]="loading"
        ></service-call-distribution-chart>
      </section>
      <section id="pest-services-metric-cards" class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 w-full">
        <ng-container *ngFor="let metric of metrics; let i = index">
          <service-metric-card
            [metricTitle]="metric.title"
            [metricKey]="metric.key"
            [serviceMetricType]="ServiceMetricTypes.Services"
            [isEnableCheckBox]="false"
          >
          </service-metric-card>
        </ng-container>
      </section>
    </section>

    <section id="pest-findings" class="bg-white flex flex-col p-6 gap-6 items-center justify-center rounded-lg border-1 border-solid border-neptune-color-primary-200">
      <section id="pest-findings-kpi" class="flex gap-6 justify-start w-full items-center pb-6 neptune-border-b-1 border-neptune-color-primary-200">
        <div id="pest-findings-title" class="text-2xl text-neptune-color-primary-700">Service Metrics | Findings</div>
        <app-service-insights-kpi-bar [kpiName]="pestKpiTypes.ScanCountKPI" [serviceType]="ServiceMetricTypes.Findings"></app-service-insights-kpi-bar>
      </section>
      <section id="pest-findings-distribution-chart" class="w-full">
        <service-call-distribution-chart
          [items]="findingDistributionItems"
          [serviceMetricType]="ServiceMetricTypes.Findings"
          [loading]="loading"
        ></service-call-distribution-chart>
      </section>
      <section id="pest-findings-metric-cards" class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 w-full">
        <ng-container *ngFor="let metric of findingMetrics; let i = index">
          <service-metric-card
            [metricTitle]="metric.title"
            [metricKey]="metric.key"
            [serviceMetricType]="ServiceMetricTypes.Findings"
            [isEnableCheckBox]="true"
          >
          </service-metric-card>
        </ng-container>
      </section>
    </section>

    <section id="pest-calls" class="bg-white flex flex-col p-6 gap-6 items-center justify-center rounded-lg border-1 border-solid border-neptune-color-primary-200">
        <section id="pest-calls-kpi" class="flex gap-6 justify-start w-full items-center pb-6 neptune-border-b-1 border-neptune-color-primary-200">
          <div id="pest-calls-title" class="text-2xl text-neptune-color-primary-700">Service Metrics | Calls</div>
          <app-service-insights-kpi-bar [kpiName]="pestKpiTypes.CallsByReasonKPI" [serviceType]="ServiceMetricTypes.CallsByReason"></app-service-insights-kpi-bar>
        </section>
      <section id="pest-calls-distribution-chart" class="w-full">
        <service-call-distribution-chart
          [items]="callDistributionItems"
          [serviceMetricType]="ServiceMetricTypes.CallsByReason"
          [loading]="loading"
        ></service-call-distribution-chart>
      </section>
      <section id="pest-calls-metric-cards" class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 w-full">
        <ng-container *ngFor="let metric of callMetrics; let i = index">
          <service-metric-card
            [metricTitle]="metric.title"
            [metricKey]="metric.key"
            [serviceMetricType]="ServiceMetricTypes.CallsByReason"
            [isEnableCheckBox]="true"
          >
          </service-metric-card>
        </ng-container>
      </section>
    </section>
  </div>

<ng-template #headerSkeletonLoader>
  <section class="flex justify-between items-center animate-pulse">
    <!-- Add All checkbox placeholder -->
    <div class="bg-white p-4 flex gap-2 items-center">
      <div class="h-4 w-4 bg-neptune-subtle rounded"></div>
      <div class="h-4 w-10 bg-neptune-subtle rounded"></div>
    </div>

    <!-- Description text + download button placeholder -->
    <div class="flex gap-4 items-center justify-center">
      <div class="h-4 w-96 bg-white rounded"></div>
      <div class="h-9 w-48 bg-white rounded-lg"></div>
    </div>
  </section>
</ng-template>
